import { Helmet } from "react-helmet";
import { SuperSEO } from "react-super-seo";
import { useEffect } from "react";

function ContactUs() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://www.aapligaadi.co.in/contact-us" />
            </Helmet>
            <SuperSEO
                title="Contact Us - Aapli Gaadi Car Rental Services"
                description="Get in touch with Aapli Gaadi for self-drive car rentals, chauffeur-driven packages, bike rentals, and station transfers across Mumbai, Navi Mumbai, Thane, and Konkan hubs."
                lang="en"
                openGraph={{
                    ogTitle: "Contact Us - Aapli Gaadi Car Rentals",
                    ogDescription: "Reach out to Aapli Gaadi 24/7 customer support for bookings, assistance, or rental enquiries.",
                    ogUrl: "https://www.aapligaadi.co.in/contact-us",
                    ogType: "website",
                    ogSiteName: "Aapli Gaadi",
                    ogLocale: "en_US"
                }}
            />

            <section className="hero-wrap hero-wrap-2 js-fullheight" style={{ backgroundImage: `url('image/aapli_gaadi_landing.png')` }} data-stellar-background-ratio="0.5">
                <div className="overlay"></div>
                <div className="container">
                    <div className="row no-gutters slider-text js-fullheight align-items-end justify-content-start">
                        <div className="col-md-9 pb-5">
                            <p className="breadcrumbs">
                                <span className="mr-2"><a href="/">Home <i className="ion-ios-arrow-forward"></i></a></span>
                                <span>Contact Us <i className="ion-ios-arrow-forward"></i></span>
                            </p>
                            <h1 className="mb-3 bread playwrite-cu-font">Contact Us</h1>
                            <p className="text-white-50 lead mb-0" style={{ fontSize: '16px' }}>
                                We are here to assist you 24/7 with your bookings and journey enquiries.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section contact-section bg-light py-5">
                <div className="container">
                    <div className="row d-flex mb-5 contact-info">
                        <div className="col-md-4">
                            <div className="row mb-5">
                                <div className="col-md-12">
                                    <div className="border bg-white w-100 p-4 rounded mb-3 d-flex align-items-center shadow-sm" style={{ borderRadius: '12px' }}>
                                        <div className="icon mr-3 text-primary" style={{ fontSize: '24px' }}>
                                            <i className="fa-solid fa-location-dot"></i>
                                        </div>
                                        <p className="mb-0 small">
                                            <strong className="d-block text-dark">Service Hubs:</strong>
                                            Mumbai, Navi Mumbai, Thane, Kudal, Malvan, Tarkarli, Sawantwadi, Ratnagiri, Ganpatipule
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="border bg-white w-100 p-4 rounded mb-3 d-flex align-items-center shadow-sm" style={{ borderRadius: '12px' }}>
                                        <div className="icon mr-3 text-primary" style={{ fontSize: '24px' }}>
                                            <i className="fa-solid fa-phone"></i>
                                        </div>
                                        <p className="mb-0 small">
                                            <strong className="d-block text-dark">Helpline / Support:</strong>
                                            <a href="tel:+917208388380" className="text-dark font-weight-bold">+91 720 838 8380</a>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="border bg-white w-100 p-4 rounded mb-3 d-flex align-items-center shadow-sm" style={{ borderRadius: '12px' }}>
                                        <div className="icon mr-3 text-primary" style={{ fontSize: '24px' }}>
                                            <i className="fa-solid fa-envelope"></i>
                                        </div>
                                        <p className="mb-0 small">
                                            <strong className="d-block text-dark">Email Enquiries:</strong>
                                            <a href="mailto:crewtechsolution@gmail.com" className="text-dark">crewtechsolution@gmail.com</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 block-9 mb-md-5">
                            <form 
                                action="https://wa.me/917208388380" 
                                target="_blank"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    const form = e.currentTarget;
                                    const name = (form.elements.namedItem('name') as HTMLInputElement)?.value || '';
                                    const email = (form.elements.namedItem('email') as HTMLInputElement)?.value || '';
                                    const message = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
                                    const text = `Hello AapliGaadi,\nEnquiry from ${name} (${email}):\n${message}`;
                                    window.open(`https://wa.me/917208388380?text=${encodeURIComponent(text)}`, '_blank');
                                }}
                                className="bg-white p-4 p-md-5 contact-form rounded border shadow-sm" 
                                style={{ borderRadius: '16px' }}
                            >
                                <h3 className="h5 font-weight-bold text-dark mb-4">Send Us a Direct Message</h3>
                                <div className="form-group">
                                    <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                                </div>
                                <div className="form-group">
                                    <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                                </div>
                                <div className="form-group">
                                    <textarea name="message" cols={30} rows={5} className="form-control" placeholder="How can we help you?" required></textarea>
                                </div>
                                <div className="form-group mb-0">
                                    <button type="submit" className="btn btn-primary py-3 px-5 shadow" style={{ borderRadius: '30px', fontWeight: 'bold' }}>
                                        Send Message on WhatsApp <i className="fa-brands fa-whatsapp ml-2"></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ContactUs;